// extracted by mini-css-extract-plugin
export default {"wrapper":"item-master_wrapper__-ZJhY","table-container":"item-master_table-container__ircCs"};